import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'

import { callProcedure } from 'clickNgo/helpers/api'
import type { IProcedureResponse } from 'clickNgo/models/api'

import { mapMdfActivityFromApi } from '../lib'
import { IMdfActivity } from '../model/types'

import { IMdfActivityApi } from './types'

interface IFetchMdfActivities {
  partnerId: string
  fYear: number
  programType: ProgramTypes
}

export const fetchMdfActivities = async ({
  partnerId,
  fYear,
  programType,
}: IFetchMdfActivities): Promise<IMdfActivity[]> => {
  const response = await callProcedure<IProcedureResponse<IMdfActivityApi[]>>({
    url: '/webservice/621/sp/v4/spJBPMDFActivities/call',
    method: 'POST',
    data: {
      'p.PartnerId': partnerId,
      'p.FYear': fYear,
      'p.ProgramType': programType,
    },
  })

  if ('error' in response) {
    throw response.error
  }

  const apiData = response.data.Data ?? []

  return apiData.map(mapMdfActivityFromApi)
}
